import React, { useRef } from 'react';
import { trackMatchInteraction } from '../../../../libraries/_modules/tracking/helpers';
import { useMatchStatus } from "../../../shared/hooks/useMatchStatus";

function MatchLink({ matchOptaId, matchPageUrl, position, slug, competitionSlug }) {
  const { status } = useMatchStatus({
    initialState: {
      matchOptaId
    }
  });

  const handleClick = (e, position, slug, status, competitionSlug) => {
    trackMatchInteraction({
      clickType: 'match',
      clickItem: 'match-unit',
      clickPosition: position,
      match: slug,
      matchState: status?.abbreviation,
      competition: competitionSlug,
    });
    e.stopPropagation();
  };

  return (
    <a href={matchPageUrl} className="mls-o-match-strip__matchhub-link"
      onClick={e => { handleClick(e, position, slug, status, competitionSlug); }} />
  );
}

// eslint-disable-next-line no-func-assign
MatchLink = React.memo(MatchLink);

export default MatchLink;
